import { useVillageEvidenceGallery } from "../hooks/useVillageEvidenceGallery";
import type { VillageEvidenceGalleryCardProps } from "./VillageEvidenceGalleryCard.types";

export function VillageEvidenceGalleryCard({ villageRef, evidenceItems, isEvidenceLoading }: VillageEvidenceGalleryCardProps) {
  const gallery = useVillageEvidenceGallery({
    evidenceItems,
    isEvidenceLoading,
    resetKey: villageRef,
    enabled: true,
    limit: 6,
  });

  return (
    <article className="box gallery-box fade-in">
      <div className="box-title-row">
        <h3>Evidence & Gallery</h3>
        <button
          type="button"
          className="secondary-button is-inline"
          onClick={gallery.toggleExpanded}
          aria-expanded={gallery.isExpanded}
        >
          {gallery.isExpanded ? "Collapse" : "Expand"}
        </button>
      </div>

      {gallery.isExpanded ? (
        <div className="village-collapsible-content">
          {gallery.isLoading ? (
            <div className="village-inline-loader" role="status" aria-live="polite" aria-label="Loading village gallery">
              <span className="village-inline-loader__spinner" aria-hidden="true" />
            </div>
          ) : gallery.mediaPreviews.length > 0 ? (
            <div className="media-strip media-strip-gallery">
              {gallery.mediaPreviews.map((preview) => (
                <figure key={preview.evidenceId} className={`thumb ${preview.mediaType === "image" ? "thumb-image" : "thumb-audio"}`}>
                  {preview.objectUrl && preview.mediaType === "image" ? (
                    <img src={preview.objectUrl} alt={preview.label} loading="lazy" />
                  ) : (
                    <figcaption className="asset-meta-card">
                      <strong>{preview.label}</strong>
                      <span>{preview.mediaType}</span>
                    </figcaption>
                  )}
                </figure>
              ))}
            </div>
          ) : (
            <p className="small-paragraph">No published site-of-conscience media is available for this village yet.</p>
          )}
        </div>
      ) : null}
    </article>
  );
}
